// src/pages/SelectTenant.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { firestore } from "../firebase.config";
import { useUserContext } from "../context/UserContext";
import { Box, Select, MenuItem, Typography, Button, InputLabel, FormControl } from "@mui/material";
import { useNavigate } from "react-router-dom";


const SelectTenant = () => {
  const [tenantList, setTenantList] = useState([]);

  const navigate = useNavigate();

  const {
    selectedTenantId,
    setSelectedTenantId,
    selectedTenantName,
    setSelectedTenantName,
  } = useUserContext();

  useEffect(() => {
    const fetchTenants = async () => {
      const snapshot = await getDocs(collection(firestore, "TenantMaster"));
      const tenants = snapshot.docs.map(doc => doc.data());
      setTenantList(tenants);
    };
    fetchTenants();
  }, []);

  const [selectedTenantLocal, setSelectedTenantLocal] = useState("");

  const handleChange = (e) => {
    const selectedId = e.target.value;
    const selected = tenantList.find((t) => t.tenantId=== selectedId);

    setSelectedTenantId(selectedId);
    setSelectedTenantName(selected?.tenantName || "");

    // Save to sessionStorage so it persists
    sessionStorage.setItem("selectedTenantId", selectedId);
    sessionStorage.setItem("selectedTenantName", selected?.tenantName || "");
  };

 const handleContinue = () => {
    if (!selectedTenantId) {
      alert("Please select a tenant.");
      return;
    }
    navigate("/dashboard");
  };

  return (
    <Box p={4}>
      <Typography variant="h5" gutterBottom>Select Tenant to Continue</Typography>
      <FormControl fullWidth>
        <InputLabel>Select Tenant</InputLabel>
        <Select
          value={selectedTenantId || ""}
          onChange={handleChange}
          label="Select Tenant"
        >
          {tenantList.map((tenant) => (
            <MenuItem key={tenant.tenantId} value={tenant.tenantId}>
              {tenant.tenantName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button variant="contained" sx={{ mt: 2 }} onClick={handleContinue}>
        Continue
      </Button>
    </Box>
  );
};

export default SelectTenant;
